import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useState } from "react";
import * as Utils from "../Utils";
var feedback = [];
var listeners = [];
function get() {
  return feedback;
}
function set(p) {
  if (feedback !== p) {
    feedback = p;
    listeners.forEach(function (listener) {
      return listener(feedback);
    });
  }
}
function append(p) {
  if (p && p.length > 0) {
    feedback = feedback.concat(p);
    listeners.forEach(function (listener) {
      return listener(feedback);
    });
  }
}
function addListener(listener) {
  listeners.push(listener);
}
function removeListener(listener) {
  listeners = listeners.filter(function (aListener) {
    return aListener !== listener;
  });
}
function fetchFeedback() {
  Utils.fetchData("application/auth/feedback", undefined, false, true).then(function (data) {
    append(data ? data : []);
  }).catch(function (error) {
    // Ignore error
    console.log(error);
  });
}
export function refresh() {
  if (listeners.length > 0) {
    fetchFeedback();
  }
}

/**
 * Hook used to access feedback..
 */
export function useFeedback() {
  var _useState = useState(get()),
    _useState2 = _slicedToArray(_useState, 2),
    feedbackLocal = _useState2[0],
    setFeedback = _useState2[1];

  /**
   * Reset the listener anytime the setter method changes.
   */
  useEffect(function () {
    var listener = function listener(newFeedback) {
      setFeedback(newFeedback);
    };
    set(feedbackLocal);
    addListener(listener);
    return function () {
      removeListener(listener);
    };
  }, [feedbackLocal]);
  return [feedbackLocal, setFeedback];
}